import type { PolyglotOptions } from "node-polyglot"
import Polyglot from "node-polyglot"
import { replaceReact } from "./replaceReact"
import type { Translation } from "src/types/Translation"
import { noticeError } from "src/utils"

type TranslationValue = Phrases | string

interface Phrases {
  [key: string]: TranslationValue;
}

interface TranslationFile {
  default: Phrases;
}

export async function loadPolyglotTranslation(
  translation: Translation, // the translation file to load, ex: "en"
  language: string, // the user's language tag that matched the translation file, ex: "en-US"
): Promise<Polyglot | undefined> {
  try {
    const localeFile = await import(`src/locales/${translation}.json`) as TranslationFile
    const phrases = localeFile.default
    const polyglot = new Polyglot({
      phrases,
      locale: language,
      /*
       * replace is not a documented option but it is supported
       * https://github.com/airbnb/polyglot.js/issues/93#issuecomment-1401558445
       * https://github.com/airbnb/polyglot.js/blob/2e29439a75c1f38a905085575555ae471db1f3fe/index.js#L267
       */
      replace: replaceReact,
    } as PolyglotOptions)

    return polyglot
  } catch (e) {
    noticeError(
      e,
      "CreatePolyglot",
      { locale: language },
    )
  }

  return undefined
}
